import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { PptReplay } from './types';

export const usePptReplayQuery = (
    gameId: string | undefined,
    eventNumber: string | undefined
): ApiResponseNHL<PptReplay> => {
    return useFetchLeagueData(`/ppt-replay/goal/${gameId}/${eventNumber}`);
};
